import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-painting-category-list',
  templateUrl: './painting-category-list.component.html',
  styleUrls: ['./painting-category-list.component.sass']
})
export class PaintingCategoryListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
